// NOTE:
// Custom zoom/pan for archival book images.
// Do NOT replace with image cropping or gallery libraries.
// Spine + margins must remain intact for historical accuracy.

(function () {
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function setupZoom(viewport, img) {
    let scale = 1;

    function apply() {
      img.style.transform = `scale(${scale})`;
    }

    function reset() {
      scale = 1;
      apply();
      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    }

    // Drag to pan (by scrolling)
    let isDown = false;
    let startX = 0, startY = 0;
    let startScrollLeft = 0, startScrollTop = 0;

    viewport.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDown = true;
      viewport.classList.add("is-grabbing");
      startX = e.clientX;
      startY = e.clientY;
      startScrollLeft = viewport.scrollLeft;
      startScrollTop = viewport.scrollTop;
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      viewport.scrollLeft = startScrollLeft - dx;
      viewport.scrollTop = startScrollTop - dy;
    });

    window.addEventListener("mouseup", () => {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove("is-grabbing");
    });

    // Wheel zoom
    viewport.addEventListener("wheel", (e) => {
      e.preventDefault();

      const rect = viewport.getBoundingClientRect();
      const offsetX = e.clientX - rect.left + viewport.scrollLeft;
      const offsetY = e.clientY - rect.top + viewport.scrollTop;

      const prevScale = scale;
      const zoomFactor = e.deltaY < 0 ? 1.08 : 0.92;
      scale = clamp(scale * zoomFactor, 1, 6);
      apply();

      const scaleRatio = scale / prevScale;
      viewport.scrollLeft = offsetX * scaleRatio - (e.clientX - rect.left);
      viewport.scrollTop  = offsetY * scaleRatio - (e.clientY - rect.top);
    }, { passive: false });

    viewport.addEventListener("dblclick", (e) => {
      e.preventDefault();
      reset();
    });

    img.addEventListener("load", reset);

    return { reset };
  }

  function init() {
    const modal = document.getElementById("imageZoomModal");
    if (!modal || modal.dataset.zoomBound === "1") return;

    const viewport = modal.querySelector("[data-zoom-viewport]");
    const img = modal.querySelector("[data-zoom-image]");
    if (!viewport || !img) return;

    // bind once
    modal.dataset.zoomBound = "1";
    const controller = setupZoom(viewport, img);

    modal.addEventListener("shown.bs.modal", () => controller.reset());
    modal.addEventListener("hidden.bs.modal", () => controller.reset());
  }

  document.addEventListener("turbo:load", init);
})();
